import styled from "styled-components";
export const StyledProductsTable = styled.div`
  td.ant-table-row-expand-icon-cell {
    text-overflow: inherit;
  }
`;
